import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { AvatarModule } from '../../components/avatar/avatar.module';
import { TemplatesModule } from '../../components/templates/templates.module';

import { AdminTemplatesRoutingModule } from './admin-templates-routing.module';
import { AdminTemplatesComponent } from './admin-templates.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AdminTemplatesRoutingModule,
    NgxDatatableModule,
    TemplatesModule,
    AvatarModule,
    SharedPipesModule,
  ],
  declarations: [AdminTemplatesComponent],
})
export class AdminTemplatesModule {}
